import React, { FC, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import styles from 'styles/components/template.module.scss'
import { MainHeadline, Description } from 'components/Typography'
import { NavButton, BlueButton } from 'components/Button'
import { Spacer } from 'components/Utility'
import { BrandList } from 'components/List'
import { Caution } from 'components/Typography'
import { FlexRow } from 'components/Flex'
import { useFetchBrands } from 'hooks/brand'
import { StoreType } from 'types/store'
import { fetchStores } from 'repos/store'

const BrandsTemplate: FC = () => {
  const { brands } = useFetchBrands()
  const dispatch = useDispatch()

  const [stores, setStores] = useState<StoreType[]>([])

  useEffect(() => {
    ;(async () => {
      const _stores = await fetchStores(['public'])
      setStores([..._stores])
    })()
  }, [])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'ブランドリスト'} />
      <Spacer size={20} />
      <Description description={'1つのブランドで、複数の店舗を管理することができます。'} />
      <Spacer size={20} />
      {brands.length > 0 ? (
        <BrandList brandList={brands} stores={stores} />
      ) : (
        <FlexRow justifyContent={'center'}>
          <Caution caution={'登録されているブランドがありません'} size={'large'} />
        </FlexRow>
      )}
      <Spacer size={48} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'新しいブランドを作成する'}
        onClick={() => dispatch(push('/admin/brand/create'))}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={24} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/admin/shops'} />
      <Spacer size={48} />
    </div>
  )
}

export default BrandsTemplate
